/// <amd-module name="TFS/NetPromoterSurvey/client/RestClient/Recommendation" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   aex\client\recommendation\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Recommendation from "../Contracts/Recommendation";

export interface IRecommendationRestClient extends IVssRestClient {
    /**
     * @param engagementId - 
     */
    read(engagementId: string): Promise<Recommendation.EngagementData>;
    /**
     */
    readEngagementIds(): Promise<string[]>;
    /**
     * @param model - 
     */
    write(model: Recommendation.EngagementData): Promise<void>;
    /**
     * @param type - 
     * @param engagementId - 
     */
    logRecommendation(type: Recommendation.RecommendationType, engagementId: string): Promise<void>;
    /**
     * POST endpoint similar to RecommendationController.GetRecommendations. The new web platform does not support complex types in GET request parameters. Solution is to put the parameter in the POST request body.
     * 
     * @param input - 
     */
    getEngagementRecommendation(input: Recommendation.RecommendationInput): Promise<Recommendation.IRecommendation>;
    /**
     * @param type - 
     * @param input - 
     */
    getRecommendations(type: Recommendation.RecommendationType, input: Recommendation.RecommendationInput): Promise<Recommendation.IRecommendation>;
}

class RecommendationRestClient extends RestClientBase implements IRecommendationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param engagementId - 
     */
    public async read(
        engagementId: string
        ): Promise<Recommendation.EngagementData> {

        const queryValues: any = {
            engagementId: engagementId
        };

        return this.beginRequest<Recommendation.EngagementData>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/Recommendation/EngagementData",
            queryParams: queryValues
        });
    }

    /**
     */
    public async readEngagementIds(
        ): Promise<string[]> {

        return this.beginRequest<string[]>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/Recommendation/EngagementData"
        });
    }

    /**
     * @param model - 
     */
    public async write(
        model: Recommendation.EngagementData
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Recommendation/EngagementData",
            body: model
        });
    }

    /**
     * @param type - 
     * @param engagementId - 
     */
    public async logRecommendation(
        type: Recommendation.RecommendationType,
        engagementId: string
        ): Promise<void> {

        const queryValues: any = {
            type: type,
            engagementId: engagementId
        };

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Recommendation/RecommendationHistory",
            queryParams: queryValues
        });
    }

    /**
     * POST endpoint similar to RecommendationController.GetRecommendations. The new web platform does not support complex types in GET request parameters. Solution is to put the parameter in the POST request body.
     * 
     * @param input - 
     */
    public async getEngagementRecommendation(
        input: Recommendation.RecommendationInput
        ): Promise<Recommendation.IRecommendation> {

        return this.beginRequest<Recommendation.IRecommendation>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Recommendation/Recommendations",
            body: input
        });
    }

    /**
     * @param type - 
     * @param input - 
     */
    public async getRecommendations(
        type: Recommendation.RecommendationType,
        input: Recommendation.RecommendationInput
        ): Promise<Recommendation.IRecommendation> {

        const queryValues: any = {
            type: type,
            input: input
        };

        return this.beginRequest<Recommendation.IRecommendation>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/Recommendation/Recommendations",
            queryParams: queryValues
        });
    }

}

export const RecommendationClientName = "IRecommendationRestClient";

export function getRecommendationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IRecommendationRestClient {
    return pageContext.getRestClient<IRecommendationRestClient>(RecommendationClientName, options);
}

RestClients.add(RecommendationClientName, { 
    factory: RecommendationRestClient,
    options: {
        serviceInstanceType: "00000041-0000-8888-8000-000000000000"
    }
});
